import { encryptTransform } from "redux-persist-transform-encrypt";
import rootReducer from ".";
import { persistReducer, persistStore } from "redux-persist";
import { configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";

const rootReducerWithClear = (state, action) => {
  if (action.type === "paydwell/clearReduxState") {
    state = undefined;
    localStorage.clear();
    sessionStorage.clear();
  }
  return rootReducer(state, action);
};

// Redux-persist configuration
const persistConfig = {
  key: "Paydwell",
  version: 1,
  storage,
  transforms: [
    encryptTransform({
      secretKey: "paydwellencryption",
      onError: (err) => {
        console.error("Persist Transform Error:", err);
      },
    }),
  ],
};

const persistedReducer = persistReducer(
  persistConfig,
  rootReducerWithClear
);

export const store = configureStore({
  reducer: persistedReducer,
  devTools: true,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);
